import { render } from "./PostBox.vue?vue&type=template&id=75f9547d&scoped=true"
import script from "./PostBox.vue?vue&type=script&lang=js"
export * from "./PostBox.vue?vue&type=script&lang=js"

import "./PostBox.vue?vue&type=style&index=0&id=75f9547d&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75f9547d"]])

export default __exports__